"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notNullOrUndefined = notNullOrUndefined;
function notNullOrUndefined(value) {
    return value != null;
}
